import { Button, Tooltip } from "antd"
import { type MouseEvent } from "react"

import PortfolioStepStatusCell, {
  renderStepStatusTooltipContent,
} from "./PortfolioStepStatusCell"
import { type PortfolioMockStage } from "./usePortfolioDbStorage"

interface StepIconButtonProps {
  stage: PortfolioMockStage
  onClick: (event: MouseEvent<HTMLElement>) => void
  /** Tighter padding (1px) for project list rows. Defaults to 2px. */
  tightPadding?: boolean
}

const StepIconButton = ({
  stage,
  onClick,
  tightPadding = false,
}: StepIconButtonProps) => (
  <Tooltip
    title={renderStepStatusTooltipContent({
      status: stage.status,
      dueDate: stage.dueDate,
      feedbackText: stage.feedback,
    })}
    mouseEnterDelay={0.2}
  >
    <Button
      type="text"
      size="small"
      aria-label={`Step ${stage.label}`}
      onClick={onClick}
      style={{
        padding: tightPadding ? 1 : 2,
        height: "auto",
        lineHeight: 0,
      }}
    >
      <PortfolioStepStatusCell status={stage.status} withTooltip={false} />
    </Button>
  </Tooltip>
)

export default StepIconButton
